import React, { useState } from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import { Button } from 'semantic-ui-react';

import { PopupButton } from '#/shared/components/ssm';
import { useStores } from '#/shared/hooks/useStores';

const errorMessage = cx('red', 'm2', 'pt4');
// const button = cx($.buttonPill, '_c1', '_b1', 'b');

export default observer(({ form, controls = null, labels = null }) => {
  const { authManagement } = useStores();

  const [canRequestMagicLink, enableMagicLinkRequest] = useState(true);

  const disableMagicLink = () => {
    enableMagicLinkRequest(false);
    setTimeout(() => enableMagicLinkRequest(true), 30000);
  };

  return (
    <div>
      <div className={cx('pt4 flex items-center justify-center')}>
        <div className={cx('flex flex-row items-center justify-center')}>
          {(!controls || controls.onSubmit) && (
            <div>
              <Button
                content={labels.submit || 'Submit'}
                disabled={form.submitting}
                icon="dot circle outline"
                loading={form.submitting || form.validating}
                onClick={form.onSubmit}
                primary={true}
                type="submit"
              />
            </div>
          )}

          {controls?.magicLink && (
            <PopupButton
              basic={true}
              className="bare"
              disabled={
                !canRequestMagicLink ||
                !form.$('email').value ||
                !form.$('email').isValid
              }
              icon="magic"
              onClick={(e) => {
                e.preventDefault();
                disableMagicLink();
                authManagement.requestMagicLink(form.values());
              }}
              primary={true}
              style={{ height: '38px' }}
              tabIndex={-1}
              tooltip="Login via Magic-Link sent to your email address"
            />
          )}
        </div>

        {(!controls || controls.onClear) && (
          <Button icon={true} onClick={form.onClear}>
            <i className="fa fa-eraser" /> {labels.clear || 'Clear'}
          </Button>
        )}

        {(!controls || controls.onReset) && (
          <Button icon={true} onClick={form.onReset}>
            <i className="fa fa-refresh" /> {labels.reset || 'Reset'}
          </Button>
        )}
        {(!controls || controls.error) && form.hasError && (
          <p className={errorMessage}>
            <i>{form.error}</i>
          </p>
        )}
      </div>
    </div>
  );
});
